import couponQueryHandler from '../../containers/Intake/couponQueryHandler';
import socialAiQuestions from '../../containers/Intake/internal/socialAiQuestions';
import socialAiSteps from '../../containers/Intake/internal/socialAiSteps';
import IntakeConfig from '../../interfaces/IntakeConfig.interface';
import planConfigCA from './planConfigCA';
import planConfigUS from './planConfigUS';

const config: IntakeConfig = {
  pageTitle: 'Social AI Business Signup',
  partner: {
    code: 'internal-intake-social-ai',
    name: 'Social AI',
    franchiseCode: '',
    logo: '',
    repEmail: '',
  },
  countries: ['CA', 'US'],
  plan: {
    countries: {
      CA: planConfigCA,
      US: planConfigUS,
    },
  },
  reps: [],
  questions: socialAiQuestions,
  steps: socialAiSteps,
  coupons: couponQueryHandler
};

export default config;
